import React from "react";

interface TravelAlertModalProps {
  onClose: () => void;
}

const TravelAlertModal: React.FC<TravelAlertModalProps> = ({
  onClose,
}) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div
        className="absolute inset-0 bg-black opacity-50"
        onClick={onClose  }
      ></div>
      <div className="relative flex items-center justify-center">
        <div
      className="bg-white p-6 rounded-lg shadow-xl max-w-md w-full m-4 overflow-y-auto"
      style={{
        maxHeight: "calc(100vh - 2rem)",
      }}
    >
      <div className="flex items-center mb-4">
        <span role="img" aria-label="alert" className="text-2xl mr-2">
          🔴
        </span>
        <h2 className="text-xl font-medium">Travel Advisory</h2>
      </div>

      <p className="text-sm mb-2">
        We hope you're dreaming of your next adventure. Before you pack
        your bags, here's a quick update.{" "}
        <span className="font-medium">
          The following regions are currently under heightened
          surveillance:
        </span>
      </p>

      <div className="flex flex-wrap gap-2 mb-4">
        {[
          "Jammu & Kashmir",
          "Punjab",
          "Haryana",
          "Rajasthan",
          "Delhi",
          "Gujarat",
          "Leh",
        ].map((region) => (
          <span
            key={region}
            className="bg-status-progress text-xs px-3 py-1 rounded-full"
          >
            {region}
          </span>
        ))}
      </div>

      <p className="text-sm mb-4">
        We recommend avoiding travel to these states till the
        authorities give a green signal.
      </p>

      <p className="text-sm font-medium mb-2">
        <span role="img" aria-label="airports" className="text-sm mr-2">
          ✈️
        </span>
        Airports at many cities have been temporarily shut until further
        notice, including
      </p>

      <div className="flex flex-wrap gap-2 mb-4">
        {[
          "Srinagar",
          "Jammu",
          "Leh",
          "Chandigarh",
          "Pathankot",
          "Bhuntar",
          "Shimla",
          "Gaggal",
          "Dharamshala",
          "Kishangarh",
          "Jaisalmer",
          "Jodhpur",
        ].map((city) => (
          <span
            key={city}
            className="bg-status-progress text-xs px-3 py-1 rounded-full"
          >
            {city}
          </span>
        ))}
      </div>

      <p className="text-sm mb-3">
        At Zostel headquarters, we are prioritising queries related to
        our North Indian properties & you can reach out to us via{" "}
        <a
          href={`https://api.whatsapp.com/send?phone=919289229822&text=${encodeURIComponent(
            "Zo. I need assistance with my booking due to the travel advisory."
          )}`}
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:text-orange font-medium"
        >
          WhatsApp
        </a>
        .
      </p>

      <p className="text-sm">
        Until then, stay safe, stay curious.
        <br />
        Team Zostel
      </p>

      <div className="flex items-center mt-4">
            <button
              onClick={onClose  }
              className="text-xs py-2 px-3 rounded-full bg-primary text-white font-medium border border-gray-400"
            >
              Got it
        </button>
        </div>
        </div>
      </div>
    </div>
  );
};

export default TravelAlertModal;
